// HTTP status codes used throughout the application
export const HTTP_STATUS = {
  CREATED: 201,
  INTERNAL_SERVER_ERROR: 500,
  OK: 200,
} as const;
